import { format } from "date-fns";
import { Typography } from "theme";

import { Box, CircularProgress, Grid2 } from "@mui/material";

import { useClearNotifications } from "../../../api/hooks/useClearNotifications/useClearNotifications.ts";
import { useNotifications } from "../../../api/hooks/useNotifications/useNotifications.ts";
import { InvertButton } from "../../../theme/components/Button/Button.tsx";

const Notifications = () => {
  const { data, isFetching } = useNotifications();

  const clearNotificationsMutation = useClearNotifications();

  if (isFetching) {
    return (
      <Grid2 mt={2} container justifyContent="center">
        <CircularProgress color="secondary" />
      </Grid2>
    );
  }

  return (
    <Grid2 p={2} container flexDirection="column">
      {data?.notifications.map((notification, index) => (
        <Box
          key={notification.id}
          py={2}
          style={{
            borderBottomWidth: 1,
            borderBottomStyle: "solid",
            borderBottomColor: "rgba(0, 0, 0, 0.12)",
          }}
        >
          <Typography variant="body2" color="error">
            {format(new Date(notification.date), "dd.MM.yyyy HH:mm")}
          </Typography>
          <Typography variant="body1" weight={index !== 0 ? "regular" : "semiBold"}>
            {notification.message}
          </Typography>
        </Box>
      ))}

      {
        !!(data?.notifications.length && data.notifications.length > 0) && <Box mt={2}>
          <InvertButton
            fullWidth
            loading={clearNotificationsMutation.isPending}
            onClick={() => clearNotificationsMutation.mutate()}
          >
            Очистити сповіщення
          </InvertButton>
        </Box>
      }
    </Grid2>
  );
};

export default Notifications;
